import { useNavigate } from "react-router-dom";
import React,{useState,useEffect, useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import HrHeader from "../HrPanel/HrHeader";
import HrSidebar from "../HrPanel/HrSideBar";
import AddBlog from "./AddBlog";
import Table from "../../components/tableComponents/Table";
import Dropdown from "../../components/dropdown/DropDown";
import { deleteBlog, fetchBlogs } from "../../redux/actions/action";
import ViewBlog from "./ViewBlog";
import EditBlog from "./EditBlog";
import DeleteBlog from "./DeleteBlog";
import BlogsHomePage from "./BlogsHomePage";

const BlogDetailsPage =  () =>{
  console.log("BlogDetailsPage Mounted!"); 
    const navigate = useNavigate()
    const [showBlogForm, setShowBlogForm] = useState(false);
    const [data, setData] = useState([]);
    const [selectedBlogs, setSelectedBlogs] = useState(null);
    const [showPopup,setShowPopup] = useState(false)
    const [showEditBlog,setShowEditBlog] = useState(false)
    const [showViewBlog,setShowViewBlog] = useState(false)
    const [showDeleteBlog,setShowDeleteBlog] = useState(false)

     const dispatch = useDispatch()
     console.log("dispatch function:", dispatch);
    const blogs = useSelector((state) => state.uploadBlog.newBlog);
    console.log("Blogs fetched from Redux:", blogs);

    const handleAddBlogClick = () => {
      setShowBlogForm(true);
    };
    const handleSave = () => {
      // Assume save logic here (e.g., save form data to the DB)
      // After saving, close the form
      closeBlogForm();
    };  

const closeBlogForm = () => {
    setShowBlogForm(false);
  };

  const openView = (blog) =>{
    setSelectedBlogs(blog);
    setShowViewBlog(true);
    
  }

  const openEdit = (blog) => {
    setSelectedBlogs(blog)
    setShowEditBlog(true);
  }

  const openDelete = (blog) => {
   setSelectedBlogs(blog)
   setShowDeleteBlog(true)
  }  

  const columns = useMemo( ()=>[{
    Header:'Blog Id',
    accessor:'id'
  },
  {Header:'Blogger Name',
  accessor:'bloggerName',
  width:20,
  },
  {
    Header:'Topic Name',
    accessor:'topicName',

  },
  {
    Header:'Role Name',
    accessor:'rolename'
  },
  {
    Header:'Description',
    accessor:'description',
    Cell: ({ value }) => (
      <div className="max-w-xs truncate hover:whitespace-normal hover:overflow-visible hover:text-clip">
        {value}
      </div>
    )
  },
  {
    Header:'Date',
    accessor:'date',
     Cell: ({ value }) => value ? new Date(value).toISOString().split("T")[0] : 'N/A'
  },
  {
    Header:'',
    accessor:'actions',
    Cell:({row})=>(
      <div className="relative"> {
        
      }
      <Dropdown
      options={['view','edit','Delete']}
       onSelect={(option) =>
        {
          if (option === 'view') openView(row.original)
          if (option === 'edit') openEdit(row.original)
          if (option === 'Delete')openDelete(row.original)
        }
          }  
          className="absolute z-50 bg-white shadow-lg"
          />
          </div>
    )
    
  }
]  ,[]
  )
  
  useEffect(()=>{
    console.log(" useEffect in BlogDetailsPage running...");
    console.log("fetchBlogs function:", fetchBlogs);
    dispatch(fetchBlogs());
  },[dispatch])

  console.log("Blogs before passing to Table:", blogs);

  console.log("First Blog Object:", blogs[0]);

  // if (!Array.isArray(blogs) || blogs.length === 0) {
  //   console.log("No blogs available in Redux!");
  //   return <p>No blogs available</p>;
  // }

    return (
        
     <div className="flex flex-row w-full  h-screen bg-[#090119] overflow-hidden"> 
         
         <HrHeader dashboardName="Blog Details" />
         <HrSidebar/>
         <div className="md:flex-1 md:ml-8 px-4 pt-24 pl-60">
        <div className="text-white">
          <div className="mb-2 pt-4 flex justify-end items-center pr-8">
         <button onClick={handleAddBlogClick}          
        
        className="bg-color hover:bg-blue-700 text-white font-bold py-2 px-4 rounded lg:w-[60px] lg:mr-[-30px] lg:absolute top-[130px] xl:w-[150px] xl:mt-2 xl:mr-40"
       > Add new blog 
        </button>

</div>

          <div className="text-white">
          <Table columns={columns} data={Array.isArray(blogs) ? blogs : []} className="w-full md:w-3/4 lg:w-2/3" />
            
            </div>
          </div>

      {showBlogForm && (
        
<div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto">
          
          <AddBlog onClose={()=>setShowBlogForm(false)} />
        </div>
    )}
 {showViewBlog && (
        <ViewBlog
          blog={selectedBlogs}
          onClose={() => setShowViewBlog(false)}
        />
       )} 

 {showEditBlog && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <EditBlog
            blog={selectedBlogs}
            onClose={() => setShowEditBlog(false)}
          />
        </div>
)}

{
  showDeleteBlog && (
    <DeleteBlog
    blog={selectedBlogs}
          onClose={() => setShowDeleteBlog(false)}
          onDelete={() => {
            dispatch(deleteBlog(selectedBlogs.id));
            setShowDeleteBlog(false);
          }}
        
    />
  )
}     

 
    
{/* } */}

        
          </div>{/*end of dark div */}

          </div>
 
    )
}
export default BlogDetailsPage